import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { memo } from "react";
import { FulfillmentNotes } from "../../../common/notes";
import {
  RedoContentCard,
  RedoContentCardReorderProps,
} from "./redo-content-card";

export const NotesCard = memo(function NotesCard({
  fulfillmentGroup,
  updateRows,
  isEditable,
  reorderHandleProps,
  showReorderHandle,
}: {
  fulfillmentGroup: FulfillmentGroupData;
  updateRows: (updates: FulfillmentGroupUpdate[]) => void;
  isEditable: boolean;
} & RedoContentCardReorderProps) {
  return (
    <RedoContentCard
      reorderHandleProps={reorderHandleProps}
      showReorderHandle={showReorderHandle}
      title="Notes"
    >
      <FulfillmentNotes
        everythingDisabled={!isEditable}
        fulfillmentGroups={[fulfillmentGroup]}
        updateRows={updateRows}
      />
    </RedoContentCard>
  );
});
